import React from 'react';
import styled, { css } from 'styled-components';
import { OptionList as RapydOptionList } from '@rapyd/react-ui-library';
import { OptionListProps } from '@rapyd/react-ui-library/dist/components/OptionList';
import { ThemeBreakpoints } from 'models';

interface IOptionListProps extends OptionListProps {}

const OptionList = ({
  className,
  name,
  staticSize = ThemeBreakpoints.SMALL,
  value,
  ...rest
}: IOptionListProps) => {
  return (
    <StyledOptionList
      className={className}
      name={name || 'option-list'}
      staticSize={staticSize}
      value={value as string}
      {...rest}
    />
  );
};

export default OptionList;

const StyledOptionList = styled(RapydOptionList)<{ value: string }>`
  .option-list-option {
    color: ${({ theme }) => theme.colors.secondaryText};

    &:hover {
      background: ${({ theme }) => theme.colors.surfaceFamilies.primaryHover};
    }

    ${({ value }) =>
    value &&
      css`
        &[data-testid$=${value}] {
          color: ${({ theme }) => theme.colors.white};
          background: ${({ theme }) => theme.colors.secondaryText};
        }
      `}
  }
`;
